<template>
  <div v-if="dataisload" class="slide-main-block">
    <template v-if="!showMobile">
      <div
        v-for="(image, index) in selectedProductImg"
        :key="image + index"
        class="d-none d-lg-block photo-item"
        @click="zoomPic(index, $event)"
      >
        <i v-if="image.VideoUrl" class="icon-play d-lg-inline-block d-none" />
        <NewImage class="mb-2 w-100" :url="image.Url" :size="'_w700_h1050'" :name="alldatas.Name" />
      </div>
      <div class="d-lg-none photo-item" @click="zoomPic(0, $event)">
        <i v-if="selectedProductImg[0].VideoMUrl" class="icon-play d-inline-block d-lg-none" />
        <NewImage
          class="mb-2 w-100"
          :url="selectedProductImg[0].Url"
          :size="'_w700_h1050'"
          :name="alldatas.Name"
        />
      </div>
    </template>
    <template v-else>
      <div
        v-for="(image, index) in selectedProductImg"
        :key="image + index"
        class="photo-item mb-3"
        @click="zoomPic(index, $event)"
      >
        <i v-if="image.VideoUrl && index !== 0" class="icon-play d-lg-inline-block d-none" />
        <NewImage class="mb-2 w-100" :url="image.Url" :size="'_w700_h1050'" :name="alldatas.Name" />
      </div>
    </template>
  </div>
</template>

<script>
import NewImage from '@global/components/global/image';
import zoomBox from '@global/components/product_vue/zoombox';
import imgTransfer from '@global/helpers/imgTransfer';
import setEnv from '@global/helpers/setEnv';

export default {
  components: {
    NewImage,
  },
  props: ['selected', 'alldatas', 'dataisload', 'nowslideindex', 'changeImage', 'showMobile'],
  computed: {
    selectedProductImg() {
      const images = [];

      this.selected.Images.forEach((element) => {
        if (element.Category === 0) images.push(element);
      });

      return images;
    },
  },
  methods: {
    zoomPic(index, event) {
      const data = [];

      this.selected.Images.forEach((element) => {
        if (element.Category === 0) data.push(element);
      });

      const newData = data.map((ele) => {
        if (ele.VideoUrl.length !== 0 || ele.VideoMUrl.length !== 0) {
          // 有影片
          return setEnv.myEquipment()
            ? imgTransfer(ele.VideoMUrl.length !== 0 ? ele.VideoMUrl : ele.Url, '')
            : imgTransfer(ele.VideoUrl.length !== 0 ? ele.VideoUrl : ele.Url, '');
        }
        return imgTransfer(ele.Url, '');
      });

      zoomBox({
        images: JSON.parse(JSON.stringify(newData)),
        index,
        yPos: event.pageY - window.scrollY,
        tilting: true,
      });
    },
  },
};
</script>
